import { Component } from '@angular/core';
import * as Chartist from 'chartist';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { DatePipe } from "@angular/common";
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { default as _rollupMoment, Moment,} from 'moment';
import { FormControl } from '@angular/forms';
import {MatDatepicker} from '@angular/material/datepicker';
import { Dashboard } from '../../models/Dashboard';
import { environment } from 'environments/environment';

const moment = _rollupMoment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MMM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-kpi6',
  templateUrl: './kpi6.component.html',
  styleUrls: ['./kpi6.component.css'],
  providers:[DatePipe,
    {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class Kpi6Component{

  date = new FormControl(moment());
  totalCartera:any=0;
  dataactual:any;
  monedaElement : any = 1255;
  loading: boolean = false;
  disable: boolean = false;
  simbolo: any = '';
  datarandom: any={
    '202411':{
      '1255':[{
        producto:"Top 1",
        cartera:17300,
        color: '#092d40' 
      },{ 
        producto:"Top 2",
        cartera:9100,
        color: '#104c6c'
      },{ 
        producto:"Top 3",
        cartera:4500,
        color: '#6e98ae'
      },{ 
        producto:"Top 4",
        cartera:2500,
        color: '#a9c5d4'
      },{ 
        producto:"Top 5",
        cartera:1500,
        color: '#c1d6e1'
      },{ 
        producto:"Otros",
        cartera:2500,
        color: '#cbcdce'
      }],
      '1447':[{
        producto:"Top 1",
        cartera:21500,
        color: '#092d40'
      },{ 
        producto:"Top 2",
        cartera:1100,
        color: '#104c6c'
      },{ 
        producto:"Top 3",
        cartera:8500,
        color: '#6e98ae'
      },{ 
        producto:"Top 4",
        cartera:6500,
        color: '#a9c5d4'
      },{ 
        producto:"Top 5",
        cartera:4800,
        color: '#c1d6e1'
      },{ 
        producto:"Otros",
        cartera:5700,
        color: '#cbcdce'
      }]
    },
    '202410':{
      '1447':[{
        producto:"Top 1",
        cartera:17300,
        color: '#092d40'
      },{ 
        producto:"Top 2",
        cartera:9100,
        color: '#104c6c'
      },{ 
        producto:"Top 3",
        cartera:4500,
        color: '#6e98ae'
      },{ 
        producto:"Top 4",
        cartera:2500,
        color: '#a9c5d4'
      },{ 
        producto:"Top 5",
        cartera:1500,
        color: '#c1d6e1'
      },{ 
        producto:"Otros",
        cartera:2500,
        color: '#cbcdce'
      }],
      '1255':[{
        producto:"Top 1",
        cartera:21500,
        color: '#092d40' 
      },{ 
        producto:"Top 2",
        cartera:1100,
        color: '#104c6c'
      },{ 
        producto:"Top 3",
        cartera:8500,
        color: '#6e98ae'
      },{ 
        producto:"Top 4",
        cartera:6500,
        color: '#a9c5d4'
      },{ 
        producto:"Top 5",
        cartera:4800,
        color: '#c1d6e1'
      },{ 
        producto:"Otros",
        cartera:5700,
        color: '#cbcdce'
      }]
    },   
  }
    
  ;
  constructor(private dashboardService:DashboardService,private datePipe: DatePipe) { }
  
  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    ctrlValue.year(normalizedMonth.year());
    this.date.setValue(ctrlValue);
    datepicker.close();
    this.getrandom(this.datePipe.transform(this.date.value._d,'yyyyMM'),this.monedaElement);
    //this.obtenerDashboardFecha();
  }
  startAnimationForLineChart(chart){
      let seq: any, delays: any, durations: any;
      seq = 0;
      delays = 80;
      durations = 500;

      chart.on('draw', function(data) {
        if(data.type === 'line' || data.type === 'area') {
          data.element.animate({
            d: {
              begin: 600,
              dur: 700,
              from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
              to: data.path.clone().stringify(),
              easing: Chartist.Svg.Easing.easeOutQuint
            }
          });
        } else if(data.type === 'point') {
              seq++;
              data.element.animate({
                opacity: {
                  begin: seq * delays,
                  dur: durations,
                  from: 0,
                  to: 1,
                  easing: 'ease'
                }
              });
          }
      });

      seq = 0;
  };
  startAnimationForBarChart(chart){
      let seq2: any, delays2: any, durations2: any;

      seq2 = 0;
      delays2 = 80;
      durations2 = 500;
      chart.on('draw', function(data) {
        if(data.type === 'bar'){
            seq2++;
            data.element.animate({
              opacity: {
                begin: seq2 * delays2,
                dur: durations2,
                from: 0,
                to: 1,
                easing: 'ease'
              }
            });
        }
      });

      seq2 = 0;
  };
  ngOnInit() {
       
      this.getrandom(this.datePipe.transform(this.date.value._d,'yyyyMM'),this.monedaElement);

      

      var datawebsiteViewsChart = {
        labels: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        series: [
          [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]

        ]
      };
      var optionswebsiteViewsChart = {
          axisX: {
              showGrid: false
          },
          low: 0,
          high: 1000,
          chartPadding: { top: 0, right: 5, bottom: 0, left: 0}
      };
      var responsiveOptions: any[] = [
        
      ];
      var websiteViewsChart = new Chartist.Bar('#websiteViewsChart', datawebsiteViewsChart, optionswebsiteViewsChart, responsiveOptions);

      //start animation for the Emails Subscription Chart
      this.startAnimationForBarChart(websiteViewsChart);

      
      /* ----------==========     Completed Tasks Chart initialization    ==========---------- */

      const dataCompletedTasksChart: any = {
        labels: ['12p', '3p', '6p', '9p', '12p', '3a', '6a', '9a'],
        series: [
            [230, 750, 450, 300, 280, 240, 200, 190]
        ]
    };

   const optionsCompletedTasksChart: any = {
        lineSmooth: Chartist.Interpolation.cardinal({
            tension: 0
        }),
        low: 0,
        high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
        chartPadding: { top: 0, right: 0, bottom: 0, left: 0}
    }

    var completedTasksChart = new Chartist.Line('#completedTasksChart', dataCompletedTasksChart, optionsCompletedTasksChart);

    // start animation for the Completed Tasks Chart - Line Chart
    this.startAnimationForLineChart(completedTasksChart);

  }
  sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
  async getrandom(periodo,monedaElement){
    this.loading = true;
    await this.sleep(3000);
    this.loading = false; 
    const data:any={series:[]};
    this.dataactual = this.datarandom[periodo][monedaElement];
    this.simbolo = (this.monedaElement == 1447)? '(#)':'(#)';    
    let smb = this.simbolo;
    this.dataactual.forEach(element => {
      data.series.push(element.cartera);
      this.totalCartera+= element.cartera;
    });
    
      var sum = function(a, b) { return a + b };
      const optionsKpiChart: any = {
        lineSmooth: Chartist.Interpolation.cardinal({
            tension: 0
        }), 
        labelInterpolationFnc: function(value) {
          return Math.round(value / data.series.reduce(sum) * 100) + '%';
        },
        low: 0,
        high: 50,
        width: 400,
        height: 400 // creative tim: we recommend you to set the high sa the biggest value + something for a better look
    }
     /* new PieChart('#kpi1', data, {
        labelInterpolationFnc: value =>
          Math.round((+value / data.series.reduce((a, b) => a + b)) * 100) + '%'
      });*/
      
      var dailySalesChart2 = new Chartist.Pie('#kpi1',data,optionsKpiChart);
      
      this.startAnimationForLineChart(dailySalesChart2);

  }
  tipoMoneda(event){
    this.monedaElement = event;
    this.getrandom(this.datePipe.transform(this.date.value._d,'yyyyMM'),this.monedaElement);
  }
}
